export default {
  columnOptions: "Column Options",
  rowsPerPage: "Rows per page",
  search: "Search",
  addButton: "Add Assets",
  blockUser: "Block User",
  unblockUser: "Unblock User",
  tags: "Tags",
  filter: "Filter",
  density: "Density",
  addModelButton: "Add Model",
  edit: "Edit",
  delete: "Delete",
  serialNo: "serialNo",
  addApp: "Add app",
  removeApp: "Remove app",
  noData: "No data Provided",
  noResultsMessage: "It looks like your current filters didn’t return any results.",
  noDataAvailable: "No data available",
  helperMessagesNoData: {
    reviewFilters: "Review or clear some filters",
    broadenCriteria: "Broaden your criteria",
    checkCombinations: "Check if you're combining filters in a way that’s too restrictive",
    chckSpelling: "Check for spelling or typos in your keyword",
    differentAttribute: "Try searching by a different attribute",
  },
  resetFilters: "Reset all filters",
  sort: "Sort",
};
